var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_PRODUCTS = 'api/product';
const GET_SET_PRODUCTS_STORES = 'api/stores';
const GET_SET_PRODUCTS_SUPPLY = 'api/product-supply';
export const create = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_PRODUCTS}`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching create:', error);
            throw error;
        }
    });
};
export const createProductSupply = function (...args) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const isStoreScoped = args.length === 3;
            const productId = isStoreScoped ? args[1] : args[0];
            const data = isStoreScoped ? args[2] : args[1];
            const url = isStoreScoped
                ? `${GET_SET_PRODUCTS_STORES}/${args[0]}/products/${productId}/supplies`
                : `${GET_SET_PRODUCTS_SUPPLY}/${productId}`;
            const response = yield this.axiosInstance.post(url, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createProductSupply:', error);
            throw error;
        }
    });
};
/**
 * @deprecated Legacy CSV product bulk-create flow. Use the XLSX `products.bulkImport` method instead.
 */
export const bulkCreate = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'multipart/form-data' // Let axios handle the boundary
                }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_PRODUCTS}/${storeId}/bulk`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error fetching products bulkCreate:', error);
            throw error;
        }
    });
};
// New: create price option for a product
export const createPriceOption = function (productId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_PRODUCTS}/${productId}/price-options`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error creating price option:', error);
            throw error;
        }
    });
};
export const bulkUpdateProductPrices = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_PRODUCTS_STORES}/${data === null || data === void 0 ? void 0 : data.storeId}/products/bulk-update-prices`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error bulk updating product prices:', error);
            throw error;
        }
    });
};
